import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { X } from "lucide-react";

const LABEL = { terms: "Terms of Service", privacy: "Privacy Policy", "community-guidelines": "Community Guidelines" };
const SEEN = "fh_legal_notice_seen";

// One-time "we've updated our terms" strip after an admin flags a change.
export const LegalNotice = () => {
    const [n, setN] = useState(null);
    useEffect(() => {
        api.get("/legal-notice").then(({ data }) => {
            if (data?.notice_at && data.notice_at > (localStorage.getItem(SEEN) || "")) setN(data);
        }).catch(() => {});
    }, []);
    if (!n) return null;
    const dismiss = () => { localStorage.setItem(SEEN, n.notice_at); setN(null); };
    return (
        <div data-testid="legal-notice" className="bg-primary text-white text-sm px-4 py-2 flex items-center justify-center gap-3">
            <span>We've updated our <Link to={`/${n.slug}`} onClick={dismiss} className="underline font-bold">{LABEL[n.slug]}</Link>.</span>
            <button onClick={dismiss} aria-label="Dismiss" data-testid="legal-notice-dismiss"><X size={14} /></button>
        </div>
    );
};
